// NotFound.jsx
import React from "react";
import { Link } from "react-router-dom";
import "../../assets/Style.css";

export default function NotFound() {
  return (
    <>
      <div className="notfound-page">
        <div className="notfound-card">

          {/* <img
          src="/logo.png" 
          alt="Logo"
          className="notfound-logo"
        /> */}

          <h1 className="error-code">404</h1>

          <h2 className="error-title">Page Not Found</h2>

          <p className="error-desc">
            The page you're looking for has been moved, deleted, or never existed.
          </p>

          <Link to="/" className="home-btn">
            Back to Home
          </Link>
        </div>

        <style>{`
      .error-code ,.error-title,.error-desc{
          text-align: center;
          }
      
      `}</style>
      </div>
    </>
  );
}